module.exports = __webpack_public_path__ + "img/1286686235.3fd65661.jpg";